/**
 * Utilitaires pour la manipulation des couleurs
 */

/**
 * Ajuste la luminosité d'une couleur hexadécimale
 * @param {string} color - La couleur en format hexadécimal (#RRGGBB ou RRGGBB)
 * @param {number} amount - La quantité à ajouter/soustraire (-255 à 255)
 * @returns {string} La couleur ajustée en format hexadécimal
 */
export const adjustColor = (color, amount) => {
  const usePound = color[0] === "#";
  const col = usePound ? color.slice(1) : color;
  const num = parseInt(col, 16);
  
  if (isNaN(num)) {
    // Si la couleur n'est pas valide, retourner la couleur par défaut
    return color;
  }
  
  let r = (num >> 16) + amount;
  let g = ((num >> 8) & 0x00FF) + amount;
  let b = (num & 0x0000FF) + amount;
  
  // Clamper les valeurs entre 0 et 255
  r = r > 255 ? 255 : r < 0 ? 0 : r;
  g = g > 255 ? 255 : g < 0 ? 0 : g;
  b = b > 255 ? 255 : b < 0 ? 0 : b;
  
  const hexColor = (r << 16 | g << 8 | b).toString(16).padStart(6, "0");
  return (usePound ? "#" : "") + hexColor;
};

/**
 * Génère un dégradé CSS pour une couleur donnée
 * @param {string} color - La couleur de base
 * @param {number} adjustment - L'ajustement de luminosité pour le dégradé
 * @returns {string} Le dégradé CSS
 */
export const generateGradient = (color, adjustment = -20) => {
  const adjustedColor = adjustColor(color, adjustment);
  return `linear-gradient(135deg, ${color} 0%, ${adjustedColor} 100%)`;
};

/**
 * Génère un dégradé avec image pour une couleur donnée
 * @param {string} color - La couleur de base
 * @param {string} imageUrl - L'URL de l'image
 * @returns {string} Le dégradé CSS avec image
 */
export const generateGradientWithImage = (color, imageUrl) => {
  return `linear-gradient(to bottom, ${color} 0%, ${color} 60%, transparent 100%), url(${imageUrl})`;
};

